import React from 'react';
import { ButtonStyled } from './styles';
var Button = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'contained' : _b, onClick = _a.onClick;
    return (React.createElement(ButtonStyled, { variant: variant, onClick: onClick }, children));
};
export default Button;
